module.exports = __webpack_public_path__ + "img/hx-kshjk.6ca4f840.svg";